<header class="header w-100 vh-100 m-0 d-none d-md-flex flex-column">
  <div class="d-flex flex-column align-items-fill justify-content-between h-100 ms-5 me-3 my-4 z-2">
    <div class="d-flex flex-column align-items-start w-50">
      <img ngSrc="https://cdn.sersoft.de/img/sersoft/logo_normal_white.svg" width="180" height="165" priority
           alt="ser.soft Logo" i18n-alt/>
      <h1 class="text-white" i18n>Digitale Lösungen für Ihren Firmenalltag</h1>
    </div>
    <button type="button" class="btn py-2 px-3 rounded-circle align-self-center" (click)="scrollTo(navbar)"
            aria-label="Zum Inhalt scrollen" i18n-aria-label>
      <i class="bi bi-chevron-down text-white fs-3"></i>
    </button>
  </div>

  <div class="w-100 vh-100 position-absolute top-0 start-0">
    @for (image of images; track image.id) {
      <div class="slide z-1 w-100 vh-100 position-absolute" [class]="`slide${image.id}`">
        <img [ngSrc]="image.image" class="w-100 h-100 object-fit-cover d-block" [alt]="image.alt" fill priority/>
      </div>
    }
  </div>
</header>

<main #navbar>
  <app-navbar [isHome]="true"/>

  <div class="card my-5 mx-0 py-5 px-4">
    <div class="d-flex flex-column gap-3 gap-sm-4 align-items-center justify-content-center text-center">
      <img ngSrc="assets/images/flag-germany.svg" alt="Deutschlandflagge" i18n-alt
           height="600" width="1000" priority style="width: 125px; height: 75px;"/>
      <h1 i18n>Quality Apps and Software<br/>Made in Germany</h1>
      @defer (hydrate on idle) {
        <p class="w-75" i18n>
          Wir sind Ihr kompetenter Partner, wenn es um die Entwicklung von kreativen mobilen Applikationen geht
          oder das Design und die Entwicklung von Individualsoftware, sowohl im Backend als auch im Frontend.
          Hierbei profitieren Sie von der langjährigen Erfahrung unserer Mitarbeiter,
          die sie in verschiedenen Projekten bei namhaften Kunden erworben haben.
          Da wir mit unserem breiten Wissen nahezu alle Bereich der Softwareentwicklung und -integration abdecken können,
          begleiten wir Sie hierbei bei Bedarf von der Konzeption über das Design und der Entwicklung bis zur
          Produktivsetzung und der anschliessenden Wartung des Systems.
          Selbst die Schulung Ihrer Mitarbeiter übernehmen wir für Sie.<br/>
          Ihr Vorteil: alles aus einer Hand.
        </p>
      }
    </div>
  </div>

  @defer (hydrate on idle) {
    <div class="card shear">
      <div class="shear-inner bg-color-before bg-before">
        <div class="inner-content d-flex flex-column justify-content-center">
          <h1 class="headline align-self-center text-center" i18n>Was wir für Sie tun</h1>
          <app-services-block/>
        </div>
      </div>
    </div>

    <div class="card shear">
      <div class="shear-inner bg-after">
        <div class="inner-content d-flex flex-column justify-content-center">
          <h1 class="headline align-self-center text-center" i18n>Aktuelle Projekte</h1>
          <app-project-slider/>
        </div>
      </div>
    </div>

    <div class="card shear">
      <div class="shear-inner bg-img bg-after">
        <div class="inner-content d-flex flex-column align-items-center justify-content-center">
          <img ngSrc="https://cdn.sersoft.de/img/sersoft/logo_normal.svg" width="273" height="250"
               alt="ser.soft Logo" i18n-alt class="w-auto mx-0 my-5" loading="lazy"/>
        </div>
      </div>
    </div>

    <div class="card shear">
      <div class="shear-inner bg-color-after bg-after">
        <div class="inner-content d-flex flex-column justify-content-center">
          <h1 class="headline align-self-center text-center" i18n>News</h1>
          <app-news-cards/>
        </div>
      </div>
    </div>
  }
</main>
